import { useMemo } from "react";
import { IReturn } from "@servicestack/client";
import { SWRConfiguration, SWRResponse } from "swr";

import useGet from "./useGet";
import { QueryResponse } from "../../api/dtos/dtos";

export interface IQueryDto<T> {
    new(query: Partial<T>): T; 
}

type QueryDto<T> = IReturn<QueryResponse<T>>;

const getData = <T>(response?: SWRResponse<QueryResponse<T>, QueryResponse<T>>) => response?.data?.results;
const getError = <T>(response?: SWRResponse<QueryResponse<T>, QueryResponse<T>>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = <T>(response?: SWRResponse<QueryResponse<T>, QueryResponse<T>>) => ({
    total: response?.data?.total ?? 0,
    offset: response?.data?.offset ?? 0,
    meta: response?.data?.meta
});

export const useQuery = <T, Q extends QueryDto<T>>(dtoClass: IQueryDto<Q>, query?: Partial<Q>,  configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new dtoClass(query)
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
};

export default useQuery;